module.exports = __webpack_public_path__ + "media/mario.33a0629b.webm";